<p-accordion value="0">
  @for (ruleset of displayRuleTypes(); track $index) {
    <app-ruleset-rule-type-field [rulesetObj]="ruleset" [accordionIndex]="$index" />
  }
</p-accordion>
<!-- PAGINATION -->
<p-paginator
  class="custom-paginator"
  [appendTo]="'body'"
  [dropdownAppendTo]="'body'"
  (onPageChange)="onPageChange($event)"
  [first]="paginator().first || 0"
  [rows]="paginator().rows || PER_PAGE"
  [totalRecords]="totalRecords()"
  [rowsPerPageOptions]="[10, 20, 50, 100]" />
